<template>
  <div class="page-content">
    <!-- 头部区域 -->
    <header class="w-full">
      <!-- 展会海报 -->
      <div class="w-full h-400">
        <img src="../assets/images/zhanhuid/top-banner-img.jpg" alt="第三十七届制冷展海报" class="w-full h-full object-cover">
      </div>

      <!-- 直播区域和展会基础信息 - 调整布局结构以对齐元素 -->
      <div class="bg-white py-6 px-16">
        <div class="flex flex-row gap-12 items-start flex-center">
          <!-- 直播区域 - 调整高度使其下缘与功能按钮下缘对齐 -->
          <div class="w-1/3 relative">
            <div class="relative w-full h-160 bg-gray-100 rounded-lg overflow-hidden">
              <img src="../assets/images/zhanhuid/image-4.jpg" alt="直播现场" class="w-full h-full object-cover">
              <div class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                <button class="w-20 h-20 rounded-full bg-white bg-opacity-20 flex items-center justify-center backdrop-filter backdrop-blur-sm">
                  <i class="fas fa-play text-white text-3xl"></i>
                </button>
              </div>
              <div class="absolute top-4 right-4 bg-red-500 text-white text-sm px-3 py-1 rounded-full live-badge">
                直播中
              </div>
            </div>
          </div>

          <!-- 展会基础信息 -->
          <div class="w-2/3">
            <div class="flex flex-col gap-4">
              <!-- 展会Logo和名称 -->
              <div class="flex items-center gap-6">
                <img src="../assets/images/zhanhuid/logo-icon.jpeg" alt="展会Logo" class="w-24 h-24 object-contain">
                <div>
                  <h1 class="text-3xl font-bold dark-blue">第三十七届制冷展</h1>
                  <p class="text-lg text-gray-600 mt-1">国际制冷、空调、供暖、通风及食品冷冻加工展览会</p>
                </div>
              </div>

              <!-- 展会详细信息 -->
              <div class="grid grid-cols-2 gap-x-12 gap-y-3">
                <div class="flex items-start gap-3">
                  <i class="fas fa-calendar-alt primary-blue mt-1"></i>
                  <div>
                    <p class="text-sm text-gray-500">开展时间</p>
                    <p class="font-medium">2026年4月8日</p>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <i class="fas fa-map-marker-alt primary-blue mt-1"></i>
                  <div>
                    <p class="text-sm text-gray-500">地点</p>
                    <p class="font-medium">上海新国际博览中心</p>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <i class="fas fa-tags primary-blue mt-1"></i>
                  <div>
                    <p class="text-sm text-gray-500">行业分类</p>
                    <p class="font-medium">制冷、空调、暖通、热泵及通风设备</p>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <i class="fas fa-building primary-blue mt-1"></i>
                  <div>
                    <p class="text-sm text-gray-500">主办单位</p>
                    <p class="font-medium">中国制冷学会、中国制冷空调工业协会等</p>
                  </div>
                </div>
              </div>

              <!-- 展会简介 -->
              <div class="info-section pl-4 py-2">
                <p class="text-gray-700 leading-relaxed">
                  中国制冷展全称为"国际制冷、空调、供暖、通风及食品冷冻加工展览会"，始创于1987年，由中国国际贸易促进委员会北京市分会、中国制冷学会、中国制冷空调工业协会共同主办，是获得国际展览业协会（UFI）、美国商务部和中国展览馆协会认证的全球制冷暖通空调行业专业展会。展会采取北京、上海两地交替举办的模式，2024年展会选址中国国际展览中心（顺义馆），2025年展会移师上海新国际博览中心。
                </p>
              </div>

              <!-- 功能入口按钮 - 保持相同宽度并添加icon -->
              <div class="flex gap-4 pt-2">
                <button class="feature-button primary-blue-bg text-white px-6 py-3 rounded-lg font-medium btn-hover">
                  <i class="fas fa-store-alt"></i>
                  申请参展
                </button>
                <button class="feature-button primary-blue-bg text-white px-6 py-3 rounded-lg font-medium btn-hover">
                  <i class="fas fa-user-plus"></i>
                  官方网站
                </button>
                <button class="feature-button primary-blue-bg text-white px-6 py-3 rounded-lg font-medium btn-hover">
                  <i class="fas fa-ticket-alt"></i>
                  购票预约
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- 主内容区域 - 直接展示内容，移除目录区域 -->
    <main class="container .w-full">
      <!-- 展会资讯 -->
      <section id="news" class="mb-16">
        <h2 class="text-2xl font-bold dark-blue mb-8 flex items-center">
          <i class="fas fa-newspaper primary-blue mr-3"></i>
          展会资讯
        </h2>

        <div class="grid grid-cols-3 gap-8">
          <!-- 资讯项1 -->
          <div class="bg-white rounded-lg overflow-hidden card-shadow">
            <img src="../assets/images/zhanhuid/image-0.jpg" alt="展会新闻" class="w-full h-48 object-cover">
            <div class="p-6">
              <h3 class="text-xl font-semibold mb-2 dark-blue">第三十七届制冷展新闻发布会在京召开</h3>
              <p class="text-gray-600 mb-4 line-clamp-3">
                近日，第三十七届制冷展新闻发布会在北京召开，主办方介绍了展会筹备情况、亮点活动及参展企业情况。本届展会预计将吸引来自全球超过30个国家和地区的1,200家企业参展。
              </p>
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-500">2025-12-15</span>
                <a href="#" class="text-primary-blue font-medium hover:underline">查看详情</a>
              </div>
            </div>
          </div>

          <!-- 资讯项2 -->
          <div class="bg-white rounded-lg overflow-hidden card-shadow">
            <img src="../assets/images/zhanhuid/image-1.png" alt="展品预览" class="w-full h-48 object-cover">
            <div class="p-6">
              <h3 class="text-xl font-semibold mb-2 dark-blue">第三十七届制冷展展品预览：聚焦绿色低碳技术</h3>
              <p class="text-gray-600 mb-4 line-clamp-3">
                第三十七届制冷展将重点展示行业最新的绿色低碳技术和产品，包括节能型制冷设备、环保制冷剂应用、智能控制系统等，引领行业向更可持续的方向发展。
              </p>
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-500">2025-12-08</span>
                <a href="#" class="text-primary-blue font-medium hover:underline">查看详情</a>
              </div>
            </div>
          </div>

          <!-- 资讯项3 -->
          <div class="bg-white rounded-lg overflow-hidden card-shadow">
            <img src="../assets/images/zhanhuid/image-2.jpg" alt="同期活动" class="w-full h-48 object-cover">
            <div class="p-6">
              <h3 class="text-xl font-semibold mb-2 dark-blue">第三十七届制冷展同期活动安排公布</h3>
              <p class="text-gray-600 mb-4 line-clamp-3">
                第三十七届制冷展期间将举办多场高水平的行业论坛、技术研讨会和产品发布会，邀请国内外专家学者和企业代表共同探讨行业发展趋势和技术创新。
              </p>
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-500">2025-11-30</span>
                <a href="#" class="text-primary-blue font-medium hover:underline">查看详情</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 展商名录 -->
      <section id="exhibitors" class="mb-16">
        <h2 class="text-2xl font-bold dark-blue mb-8 flex items-center">
          <i class="fas fa-building primary-blue mr-3"></i>
          展商名录
        </h2>

        <div class="grid grid-cols-4 gap-6">
          <!-- 展商1 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo1.jpeg" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">格力电器股份有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E1-100</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">空调设备</span>
            </div>
          </div>

          <!-- 展商2 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo2.jpeg" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">海尔智家股份有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E1-200</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">智能制冷</span>
            </div>
          </div>

          <!-- 展商3 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo3.png" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">美的集团股份有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E2-100</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">暖通设备</span>
            </div>
          </div>

          <!-- 展商4 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo4.jpeg" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">大金（中国）投资有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E2-200</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">热泵技术</span>
            </div>
          </div>

          <!-- 展商5 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo5.png" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">海信家电集团股份有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E3-100</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">通风设备</span>
            </div>
          </div>

          <!-- 展商6 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo6.jpeg" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">松下电器（中国）有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E3-200</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">冷冻设备</span>
            </div>
          </div>

          <!-- 展商7 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo7.jpeg" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">奥克斯空调股份有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E4-100</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">制冷配件</span>
            </div>
          </div>

          <!-- 展商8 -->
          <div class="bg-white rounded-lg p-6 card-shadow exhibitor-card">
            <div class="flex justify-center mb-4">
              <img src="../assets/images/zhanhuid/企业logo8.jpeg" alt="展商Logo" class="w-24 h-24 object-contain">
            </div>
            <h3 class="text-lg font-semibold text-center dark-blue mb-2">富士通将军（上海）有限公司</h3>
            <div class="flex justify-between text-sm text-gray-600 mb-1">
              <span>展位号:</span>
              <span class="font-medium">E4-200</span>
            </div>
            <div class="flex justify-between text-sm text-gray-600">
              <span>行业类别:</span>
              <span class="font-medium">控制系统</span>
            </div>
          </div>
        </div>

        <!-- 查看更多按钮 -->
        <div class="flex justify-center mt-10">
          <button class="border-2 border-primary-blue text-primary-blue px-8 py-3 rounded-lg font-medium hover:bg-primary-blue hover:text-white transition-colors">
            查看更多展商
          </button>
        </div>
      </section>

      <!-- 资料下载 -->
      <section id="downloads" class="mb-16">
        <h2 class="text-2xl font-bold dark-blue mb-8 flex items-center">
          <i class="fas fa-download primary-blue mr-3"></i>
          资料下载
        </h2>

        <div class="bg-white rounded-lg overflow-hidden card-shadow">
          <div class="grid grid-cols-3 divide-x divide-gray-200">
            <!-- 展会导览图 -->
            <div class="download-item p-8 flex flex-col items-center text-center">
              <div class="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mb-6">
                <i class="fas fa-map-marked-alt primary-blue text-3xl"></i>
              </div>
              <h3 class="text-xl font-semibold dark-blue mb-3">展会导览图</h3>
              <p class="text-gray-600 mb-6">详细的展馆布局和展位分布地图，帮助您快速找到目标展商和活动区域。</p>
              <a href="#" class="inline-flex items-center text-primary-blue font-medium hover:underline">
                <i class="fas fa-file-pdf mr-2"></i>
                下载PDF
              </a>
            </div>

            <!-- 展会手册 -->
            <div class="download-item p-8 flex flex-col items-center text-center">
              <div class="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mb-6">
                <i class="fas fa-book primary-blue text-3xl"></i>
              </div>
              <h3 class="text-xl font-semibold dark-blue mb-3">展会手册</h3>
              <p class="text-gray-600 mb-6">包含展会日程安排、活动详情、参展指南等全面信息，助您高效参观。</p>
              <a href="#" class="inline-flex items-center text-primary-blue font-medium hover:underline">
                <i class="fas fa-file-pdf mr-2"></i>
                下载PDF
              </a>
            </div>

            <!-- 参展商手册 -->
            <div class="download-item p-8 flex flex-col items-center text-center">
              <div class="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mb-6">
                <i class="fas fa-user-tie primary-blue text-3xl"></i>
              </div>
              <h3 class="text-xl font-semibold dark-blue mb-3">参展商手册</h3>
              <p class="text-gray-600 mb-6">专为参展商准备的详细指南，包括展位搭建、物流、住宿等实用信息。</p>
              <a href="#" class="inline-flex items-center text-primary-blue font-medium hover:underline">
                <i class="fas fa-file-pdf mr-2"></i>
                下载PDF
              </a>
            </div>
          </div>
        </div>
      </section>

      <!-- 交通指南 -->
      <section id="transportation">
        <h2 class="text-2xl font-bold dark-blue mb-8 flex items-center">
          <i class="fas fa-map-signs primary-blue mr-3"></i>
          交通指南
        </h2>

        <div class="bg-white rounded-lg overflow-hidden card-shadow">
          <div class="grid grid-cols-3 divide-x divide-gray-200">
            <!-- 地铁线路 -->
            <div class="p-8">
              <div class="flex items-center mb-6">
                <div class="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4">
                  <i class="fas fa-subway primary-blue text-xl"></i>
                </div>
                <h3 class="text-xl font-semibold dark-blue">地铁线路</h3>
              </div>
              <ul class="space-y-4">
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">2号线 - 龙阳路站</p>
                    <p class="text-gray-600 text-sm mt-1">从6号出口步行约10分钟到达展馆</p>
                  </div>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">7号线 - 花木路站</p>
                    <p class="text-gray-600 text-sm mt-1">从5号出口步行约8分钟到达展馆</p>
                  </div>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">16号线 - 龙阳路站</p>
                    <p class="text-gray-600 text-sm mt-1">从6号出口步行约10分钟到达展馆</p>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 公交线路 -->
            <div class="p-8">
              <div class="flex items-center mb-6">
                <div class="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4">
                  <i class="fas fa-bus primary-blue text-xl"></i>
                </div>
                <h3 class="text-xl font-semibold dark-blue">公交线路</h3>
              </div>
              <ul class="space-y-4">
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">989路 - 上海新国际博览中心站</p>
                    <p class="text-gray-600 text-sm mt-1">直达展馆东入口</p>
                  </div>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">大桥六线 - 上海新国际博览中心站</p>
                    <p class="text-gray-600 text-sm mt-1">直达展馆南入口</p>
                  </div>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">浦东11路 - 上海新国际博览中心站</p>
                    <p class="text-gray-600 text-sm mt-1">直达展馆西入口</p>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 其他公共交通 -->
            <div class="p-8">
              <div class="flex items-center mb-6">
                <div class="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4">
                  <i class="fas fa-taxi primary-blue text-xl"></i>
                </div>
                <h3 class="text-xl font-semibold dark-blue">其他交通</h3>
              </div>
              <ul class="space-y-4">
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">出租车</p>
                    <p class="text-gray-600 text-sm mt-1">展馆周边设有多个出租车上下客点</p>
                  </div>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">共享单车</p>
                    <p class="text-gray-600 text-sm mt-1">展馆周边设有多个共享单车停放点</p>
                  </div>
                </li>
                <li class="flex items-start">
                  <i class="fas fa-circle text-xs primary-blue mt-2 mr-2"></i>
                  <div>
                    <p class="font-medium">自驾车</p>
                    <p class="text-gray-600 text-sm mt-1">展馆周边设有多个停车场，收费标准：10元/小时</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
export default {
  name: "Monthly"
}
</script>

<style scoped>
.flex-center{
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}

.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}
body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #F9FAFB;
  color: #1F2937;
  width: 1920px;
  margin: 0 auto;
  overflow-x: hidden;
}

.container {
  width: 1260px;
  margin: 0 auto;
}

.primary-blue {
  color: #2563EB;
}

.primary-blue-bg {
  background-color: #2563EB;
}

.dark-blue {
  color: #204E9C;
}

.dark-blue-bg {
  background-color: #204E9C;
}

.bg-light {
  background-color: #F9FAFB;
}

.card-shadow {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.btn-hover:hover {
  background-color: #1D4ED8;
  transition: background-color 0.3s ease;
}

.live-badge {
  position: relative;
  padding-left: 20px;
}

.live-badge::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #EF4444;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(239, 68, 68, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
  }
}

.exhibitor-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.exhibitor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.info-section {
  border-left: 4px solid #2563EB;
}

.download-item {
  transition: background-color 0.3s ease;
}

.download-item:hover {
  background-color: #EFF6FF;
}

.feature-button {
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
